<template>
  <div class="bankDtlcontent">
    <span class="closeCstmpop" @click="closeCustompop()">
      <i class="material-icons">close</i>
    </span>
    <h2>{{$t('modeToReturnPayment')}}</h2>
    <div class="note">
    <p>* Refund in paytm (takes up to 7 days)</p>
    <p>* Refund in mall91 wallet (fast and instant)</p>
    </div>
    <select v-model="bankDetailsDTO.paymentMode" class="selectTypepay" name="sortBy" id="sortBy" @change="sortBy(bankDetailsDTO.paymentMode)">
      <option v-for="op in paymentModeList" :value="op.value">{{op.name}}</option>
    </select>

    <div class="viewPortcnt">
      <div class="payBackstatusbox" v-if="bankDetailsDTO.paymentMode=='PAYTM'">
        <h3>{{$t('paytmDetail')}}</h3>
        <input
          type="number"
          v-model="bankDetailsDTO.phone"
          class="inputtextbg"
          :placeholder="$t('enterPaytmNumber')"
        />
        
      </div>
      <div class="payBackstatusbox" v-if="bankDetailsDTO.paymentMode=='BANK_UPI'">
        <h3>{{$t('uPIDetail')}}</h3>
        <input
          type="text"
          v-model="bankDetailsDTO.bankUpiId"
          class="inputtextbg"
          :placeholder="$t('enterUPINumber')"
        />
        
      </div>
      <div class="payBackstatusbox" v-if="bankDetailsDTO.paymentMode=='BANK'">
        <h3>{{$t('bankDetail')}}</h3>
        <input
          type="text"
          v-model="bankDetailsDTO.accountHolderName"
          class="inputtextbg"
          :placeholder="$t('accountHolderName')"
        />
        <input
          type="text"
          v-model="bankDetailsDTO.accountNumber"
          class="inputtextbg"
          :placeholder="$t('accountNumber')"
        />
        <input
          type="text"
          v-model="bankDetailsDTO.ifc"
          class="inputtextbg"
          :placeholder="$t('bankIfscCode')"
        />
        <input
          type="text"
          v-model="bankDetailsDTO.branchName"
          class="inputtextbg"
          :placeholder="$t('branchName')"
        />
        <input
          type="text"
          v-model="bankDetailsDTO.bankName"
          class="inputtextbg"
          :placeholder="$t('bankName')"
        />
       
      </div>
       <span class="paySubmit" @click="addBankDetails">{{$t('submit')}}</span>
    </div>
    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import constant from "../../utils/constant";
import CustomToaster from "../Common/CustomToaster";
export default {
  name: "AddBankDetails",
  components: {
    CustomToaster
  },
  data() {
    return {
      // paymentModeList: ["PAYTM", "BANK"],
      paymentModeList: [
        {name: "Paytm", value: "PAYTM"}, {name: "Mall91 Wallet" , value: "MALL91_WALLET"}, {name: "Bank UPI" , value: "BANK_UPI"}],
      bankDetailsDTO: {
        paymentMode: "MALL91_WALLET"
      },
      loading: false,
      isValidDetail: false,
      toasterData: {}
    };
  },
  props:{
    returnId: String
  },
  methods: {
    sortBy(mode){
      this.bankDetailsDTO = {
        paymentMode : mode
      }
    },
    closeCustompop() {
      document.querySelector("body").classList.remove("bankDetailbody");
    },
    addBankDetails() {
      this.loading = true;
      if(this.bankDetailsDTO.paymentMode === 'BANK_UPI'){
        if(this.bankDetailsDTO.bankUpiId){
          if(this.bankDetailsDTO.bankUpiId.trim().length > 4){            
            if ((new RegExp(/^\w+@\w+$/g).test(this.bankDetailsDTO.bankUpiId))){
               this.$store
                .dispatch({
                  type: "postOrderReturnUrl",
                  payload: this.returnId,
                  postValue: this.bankDetailsDTO
                })
                .then(data => {
                  this.loading = false;
                  this.closeCustompop();
                })
                .catch(err => {
                  this.loading = false;
                  console.log(err)
                });
            }else{
              this.loading = false;
              this.toasterData = {
                msg: 'Enter Valid UPI ID',
                color: "#e51c24",
                iconName: "close",
              };
              this.isValidDetail = true;
              return false;
            }
          }else{
            this.loading = false;
            this.toasterData = {
              msg: 'Enter Valid UPI ID',
              color: "#e51c24",
              iconName: "close",
            };
            this.isValidDetail = true;
            return false;
          }
        }else{
          this.loading = false;
          this.toasterData = {
            msg: 'Enter your UPI ID',
            color: "#e51c24",
            iconName: "close",
          };
          this.isValidDetail = true;
          return false;
        }
      }else if(this.bankDetailsDTO.paymentMode === 'PAYTM'){
        if(this.bankDetailsDTO.phone){
          if(this.bankDetailsDTO.phone.trim().length > 9){
            if ((new RegExp(/^[0][6-9]\d{9}$|^[6-9]\d{9}$/g).test(this.bankDetailsDTO.phone))){
              this.$store
                .dispatch({
                  type: "postOrderReturnUrl",
                  payload: this.returnId,
                  postValue: this.bankDetailsDTO
                })
                .then(data => {
                  this.loading = false;
                  this.closeCustompop();
                })
                .catch(err => {
                  this.loading = false;
                  console.log(err)
                });
            }else{
              this.loading = false;
              this.toasterData = {
                msg: 'Enter Valid Mobile Number',
                color: "#e51c24",
                iconName: "close",
              };
              this.isValidDetail = true;
              return false;
            }
          }else{
            this.loading = false;
            this.toasterData = {
              msg: 'Enter Valid Mobile Number',
              color: "#e51c24",
              iconName: "close",
            };
            this.isValidDetail = true;
            return false;
          }
        }else{
          this.loading = false;
          this.toasterData = {
            msg: 'Enter your Paytm Number',
            color: "#e51c24",
            iconName: "close",
          };
          this.isValidDetail = true;
          return false;
        }
      }else{
        this.$store
        .dispatch({
          type: "postOrderReturnUrl",
          payload: this.returnId,
          postValue: this.bankDetailsDTO
        })
        .then(data => {
          this.loading = false;
          this.closeCustompop();
        })
        .catch(err => {
          this.loading = false;
          console.log(err)
        });
      }
      
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
  .note{
    p{
      color: #696767;
      font-size: 0.875em;
      margin-top: 8px;
    }
  }
</style>